import React from 'react'
// components
import Input from 'components/FormElements/Input'
import { Button, BUTTON_LAYOUTS } from 'components/UI'
// views
import { ButtonsContainer, Description, PromptChip, PromptsWrapper } from './views'

interface Props {
  required?: boolean
  onCancel: () => void
  onConfirm: (prompt: string) => void
  description: string
  placeholder?: string
  suggestedPrompts?: string[]
}

const AiPrompt: React.FC<Props> = ({
  required,
  onConfirm,
  onCancel,
  description,
  placeholder,
  suggestedPrompts = []
}) => {
  const [prompt, setPrompt] = React.useState('')

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPrompt(e.target.value)
  }

  const handleConfirm = () => {
    onConfirm(prompt)
  }

  return (
    <>
      <Description>{description}</Description>
      <Input
        debounced
        fullWidth
        multiline
        maxRows={5}
        value={prompt}
        name='ai-prompt'
        onChange={onChange}
        placeholder={placeholder}
      />
      {!!suggestedPrompts.length && (
        <PromptsWrapper>
          {suggestedPrompts.map((suggestedPrompt, index) => (
            <PromptChip key={index} type='button' onClick={() => setPrompt(suggestedPrompt)}>
              {suggestedPrompt}
            </PromptChip>
          ))}
        </PromptsWrapper>
      )}
      <ButtonsContainer>
        <Button shadowLess layout={BUTTON_LAYOUTS.PURPLE} onClick={handleConfirm} disabled={required && !prompt.trim()}>
          Confirm
        </Button>
        <Button shadowLess layout={BUTTON_LAYOUTS.PURPLE_INVERTED} onClick={onCancel}>
          Cancel
        </Button>
      </ButtonsContainer>
    </>
  )
}

export default AiPrompt
